import { DeleteOutlined } from '@ant-design/icons';
import { Button, Modal, Typography } from 'antd';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import {
	useDeleteCustomDashboardMutation
} from 'src/redux/services/centralApi';

interface IDeleteCustomDashboardProps {
	id: string;
}

export default function DeleteCustomDashboard({
	id,
}: IDeleteCustomDashboardProps) {
	const [ open, setOpen, ] = useState(false);
	const [ deleteCustomDashboard, ] = useDeleteCustomDashboardMutation();

	return (
		<>
			<Button
				type="text"
				danger
				icon={<DeleteOutlined />}
				onClick={() => setOpen(true)}
			/>
			<Modal
				centered
				title={'Deletar'}
				open={open}
				onCancel={() => {
					setOpen(false);
					toast.info('Operação cancelada!', { autoClose: 1000, });
				}}
				destroyOnHidden
				okText='Deletar'
				onOk={() => {
					deleteCustomDashboard(id)
						.unwrap()
						.then(() => {
							toast.success(
								'Conjunto de indicadores deletado com sucesso!',
								{ autoClose: 1000, }
							);
						})
						.catch(() => {
							toast.error(
								'Erro ao deletar conjunto de indicadores!',
								{ autoClose: 1000, }
							);
						})
						.finally(() => {
							setOpen(false);
						});
				}}
				confirmLoading={false}
			>
				<Typography.Text>
                    Você tem certeza que deseja deletar o conjunto de
                    indicadores?
				</Typography.Text>
			</Modal>
		</>
	);
}
